import { useLazyGetCashDocumentPdfQuery } from '../Service/extendedCashDocumentsApi';

export const downloadCashDocumentPdf = async (
  triggerGetPdf: ReturnType<typeof useLazyGetCashDocumentPdfQuery>[0],
  cashDocumentId: number,
  fileName: string
): Promise<void> => {
  const pdfBlob = await triggerGetPdf(cashDocumentId).unwrap();

  if (!(pdfBlob instanceof Blob) || pdfBlob.size === 0) {
    throw new Error('Downloaded cash document PDF is empty.');
  }

  const url = window.URL.createObjectURL(pdfBlob);

  try {
    const link = window.document.createElement('a');
    link.href = url;
    link.download = fileName;
    window.document.body.appendChild(link);
    link.click();
    window.document.body.removeChild(link);
  } finally {
    window.URL.revokeObjectURL(url);
  }
};
